import React from 'react';
import PropTypes from 'prop-types';

import { DrillDownLinks } from 'components/content/DrillDownLinks';

import './movingTruckContent.scss';

export function MovingTruckContent({ city, content }) {
	return (
		<div className="moving-truck-content">
			{!!content.drillDownLinks && !!content.drillDownLinks.vehicleStorage &&
				<DrillDownLinks
					headline={`Browse ${city} Storage by Type`}
					links={content.drillDownLinks.vehicleStorage}
				/>
			}
		</div>
	);
}

MovingTruckContent.propTypes = {
	city: PropTypes.string,
	content: PropTypes.shape({
		drillDownLinks: PropTypes.shape({
			vehicleStorage: PropTypes.any
		})
	})
};

export default MovingTruckContent;
